export default {
  // 授權狀態（DeviceLicense 與 ProductionToken 燒錄記錄共用）
  'pages.deviceLicense.status.allocated': '已錄入',
  'pages.deviceLicense.status.activated_pending': '已啟用待接入',
  'pages.deviceLicense.status.active': '已接入',
  'pages.deviceLicense.status.serial_mismatch': '裝置燒錄序列號和平臺下發不一致',
  'pages.deviceLicense.status.revoked': '已吊銷',
  'pages.deviceLicense.status.expired': '已過期',
  'pages.deviceLicense.burnStatus.pending': '未燒錄',
  'pages.deviceLicense.burnStatus.success': '燒錄成功',

  // DeviceLicense
  'pages.deviceLicense.column.serialNumber': '產線序列號',
  'pages.deviceLicense.column.burnStatus': '燒錄狀態',
  'pages.deviceLicense.column.productionTokenName': '歸屬產線 Token',
  'pages.deviceLicense.rule.tenantRequired': '請選擇所屬企業',
  'pages.deviceLicense.rule.deviceIdRequired': '請輸入裝置MAC',
  'pages.deviceLicense.batch.tooltip': '支援逗號、空格或換行分隔，自動去重',
  'pages.deviceLicense.batch.devicesRequired': '請輸入裝置MAC列表',

  // TenantInfo
  'pages.tenantInfo.rule.nameRequired': '請輸入企業名稱',
  'pages.tenantInfo.type.commercial': '商業版',
  'pages.tenantInfo.type.legacy': '歷史/零售',
  'pages.tenantInfo.type.internal': '內部',
  'pages.tenantInfo.status.active': '正常',
  'pages.tenantInfo.status.inactive': '停用',
  'pages.tenantInfo.maxDevices.tooltip': '該企業可授權/接入的裝置上限；也可在清單中透過「新增接入數量」累加',
  'pages.tenantInfo.addMax.button': '新增接入數量',
  'pages.tenantInfo.addMax.success': '已累加，當前可接入裝置總數：{count}',
  'pages.tenantInfo.addMax.failed': '操作失敗',
  'pages.tenantInfo.addMax.incrementLabel': '本次增加數量',
  'pages.tenantInfo.addMax.incrementRequired': '請輸入大於 0 的數量',

  // ProductionToken
  'pages.productionToken.title': '產線燒錄 Token',
  'pages.productionToken.filterHint': '當前列表已按產品分類（ID: {id}）篩選，可在位址列去掉引數檢視全部。',
  'pages.productionToken.firmware.currentNoCategory': '{version}（當前，無產品分類繫結）',
  'pages.productionToken.firmware.currentNotInList': '{version}（當前/未在列表）',

  'pages.productionToken.column.tenant': '所屬企業',
  'pages.productionToken.column.productCategoryId': '產品分類 ID',
  'pages.productionToken.column.name': '名稱',
  'pages.productionToken.column.boardType': '主機板型號',
  'pages.productionToken.column.status': '狀態',
  'pages.productionToken.column.burnedLimit': '已簽發/上限',
  'pages.productionToken.column.serialIssued': '已簽發序列號',
  'pages.productionToken.column.autoAllocate': '自動分配MAC',
  'pages.productionToken.column.serialPrefix': '序列字首',
  'pages.productionToken.column.lastUsedAt': '最近使用',
  'pages.productionToken.column.expiresAt': 'Token 過期',

  'pages.productionToken.status.enabled': '啟用',
  'pages.productionToken.status.disabled': '停用',
  'pages.productionToken.yes': '是',
  'pages.productionToken.no': '否',

  'pages.productionToken.action.burnRecords': '燒錄記錄',
  'pages.productionToken.action.edit': '編輯',
  'pages.productionToken.action.rotate': '輪換',
  'pages.productionToken.action.add': '新建 Token',
  'pages.productionToken.confirm.delete': '確定刪除？',

  'pages.productionToken.msg.rotateFailed': '輪換失敗',
  'pages.productionToken.msg.deleted': '已刪除',
  'pages.productionToken.msg.deleteFailed': '刪除失敗',
  'pages.productionToken.msg.createSuccess': '建立成功',
  'pages.productionToken.msg.createFailed': '建立失敗',
  'pages.productionToken.msg.saved': '已儲存',
  'pages.productionToken.msg.saveFailed': '儲存失敗',
  'pages.productionToken.msg.loadBurnFailed': '載入燒錄記錄失敗',

  'pages.productionToken.rule.tenantRequired': '請選擇企業',
  'pages.productionToken.rule.categoryRequired': '請選擇產品分類',

  'pages.productionToken.add.title': '新建產線 Token',
  'pages.productionToken.add.categoryLabel': '產品分類（主機板型號）',
  'pages.productionToken.add.categoryTooltip':
    '從本企業已維護的產品分類中選擇；主機板型號取分類中的「產品裝置型號」，與 OTA board.type、ota_bin 子目錄一致',
  'pages.productionToken.add.firmwareTooltip': '不選則使用產線預設或該分類最新韌體；選項來自該產品分類已上傳的韌體',
  'pages.productionToken.add.autoAllocateTooltip': '關閉時僅允許已預錄入 MAC 的裝置拉取授權',
  'pages.productionToken.add.expiresTooltip': '可選，僅選日期；不選表示不過期',

  'pages.productionToken.edit.title': '編輯產線 Token',
  'pages.productionToken.edit.firmwareTooltip': '不選則使用產線預設或該分類最新韌體；選項來自 Token 繫結分類下的韌體列表',
  'pages.productionToken.edit.expiresTooltip': '可選；清空後儲存則不在此修改過期時間（清除過期需後續介面支援）',

  'pages.productionToken.field.firmwareVersion': '鎖定韌體版本',
  'pages.productionToken.field.serialPrefix': '序列號字首',
  'pages.productionToken.field.autoAllocate': '自動分配 MAC 授權',
  'pages.productionToken.field.maxBurnCount': '最大燒錄次數',
  'pages.productionToken.field.maxBurnTooltip': '0 表示不限制',
  'pages.productionToken.field.expiresAt': 'Token 過期時間',
  'pages.productionToken.field.remark': '備註',
  'pages.productionToken.field.status': '狀態',

  'pages.productionToken.placeholder.selectVersion': '請選擇版本',
  'pages.productionToken.placeholder.selectCategoryFirst': '請先選擇產品分類',

  'pages.productionToken.secret.title': '請立即儲存（關閉後無法再次檢視明文 Token）',
  'pages.productionToken.secret.saved': '已儲存',
  'pages.productionToken.secret.urlLabel': '授權 URL 模板（寫入燒錄工具 config.json 的 license_url）',

  'pages.productionToken.burn.title': '燒錄記錄',
  'pages.productionToken.burn.titleWith': '燒錄記錄 — {name}',
  'pages.productionToken.burn.boardInfo': '主機板型號：{boardType}；已簽發序列號裝置數：',
  'pages.productionToken.burn.limitSuffix': ' / 上限 {max}',
  'pages.productionToken.burn.column.deviceId': '裝置 MAC',
  'pages.productionToken.burn.column.serialNumber': '產線序列號',
  'pages.productionToken.burn.column.status': '授權狀態',
  'pages.productionToken.burn.column.boardType': '型號',
  'pages.productionToken.burn.column.burnedAt': '簽發時間',
  'pages.productionToken.burn.column.activatedAt': '首次接入',
  'pages.productionToken.burn.column.source': '來源',

  // 通用（多頁共享）
  'pages.common.operation': '操作',
  'pages.common.deleteSuccess': '刪除成功',
  'pages.common.deleteFailed': '刪除失敗',
  'pages.common.saveSuccess': '儲存成功',
  'pages.common.saveFailed': '儲存失敗',

  // Tenant（企業：列表列/表單/列舉共享，TenantInfo 使用）
  'pages.tenant.logo.typeError': '只能上傳圖片檔案',
  'pages.tenant.logo.sizeError': '圖片大小不能超過 1MB',
  'pages.tenant.logo.success': '上傳成功',
  'pages.tenant.logo.uploadFailed': '上傳失敗',
  'pages.tenant.logo.upload': '上傳Logo',
  'pages.tenant.logo.clear': '移除',
  'pages.tenant.modal.title': '企業資訊',
  'pages.tenant.modal.profileTitle': '維護企業資料',
  'pages.tenant.column.code': '授權編碼',
  'pages.tenant.code.tip': '授權編碼由系統生成，不可修改',
  'pages.tenant.code.auto': '儲存後自動生成',
  'pages.tenant.column.name': '企業名稱',
  'pages.tenant.column.type': '型別',
  'pages.tenant.column.status': '狀態',
  'pages.tenant.column.maxDevices': '可接入裝置總數',
  'pages.tenant.column.contactName': '聯絡人',
  'pages.tenant.column.contactPhone': '聯絡電話',
  'pages.tenant.column.expiresAt': '到期時間',
  'pages.tenant.column.remark': '備註',
  'pages.tenant.column.supplierLogo': '企業Logo',
  'pages.tenant.column.activatedDevices': '啟用裝置數量',
  'pages.tenant.column.licensedDevices': '已授權裝置數量',
  'pages.tenant.column.availableDevices': '可授權裝置數量',
  'pages.tenant.maxDevices.unlimited': '不限制',
  'pages.tenant.confirm.delete': '確定刪除該企業嗎？',
  'pages.tenant.add': '新增企業',

  // License（裝置授權：列表列/表單共享，DeviceLicense 使用）
  'pages.license.column.tenant': '所屬企業',
  'pages.license.column.deviceId': '裝置MAC',
  'pages.license.column.status': '狀態',
  'pages.license.column.batchNo': '批次號',
  'pages.license.column.boardType': '型號',
  'pages.license.column.source': '授權來源',
  'pages.license.source.manual': '手工錄入',
  'pages.license.source.import': '批次匯入',
  'pages.license.source.production': '產線簽發',
  'pages.license.source.production_preregister': '產線預錄入',
  'pages.license.source.legacy_migrate': '歷史遷移',
  'pages.license.column.activatedAt': '首次接入',
  'pages.license.column.createdAt': '錄入時間',
  'pages.license.column.expiresAt': '到期時間',
  'pages.license.confirm.delete': '確定刪除該授權嗎？',
  'pages.license.add': '新增授權',
  'pages.license.batchAdd': '批次匯入',
  'pages.license.modal.addTitle': '新增裝置授權',
  'pages.license.batch.title': '批次匯入裝置授權',
  'pages.license.batch.devices': '裝置MAC',
  'pages.license.batch.result': '匯入完成：成功 {added}，跳過 {skipped}',
};
